import PositionFormView from "./PositionFormView";

function PositionForm({
  setPrinterData,
  selectedLabelItem,
  selectedLabelItemIndex,
  submitError,
}) {
  /**
   * This method will handle the on x position change event.
   * @param {event} e
   */
  function onXPositionChange(e) {
    setPrinterData((prev) => ({
      ...prev,
      label_items: prev.label_items.map((item, index) =>
        index === selectedLabelItemIndex
          ? {
              ...item,
              position: {
                ...item.position,
                x: e.target.value,
              },
            }
          : item
      ),
    }));
  }

  /**
   * This method will handle the on y position change event.
   * @param {event} e
   */
  function onYPositionChange(e) {
    setPrinterData((prev) => ({
      ...prev,
      label_items: prev.label_items.map((item, index) =>
        index === selectedLabelItemIndex
          ? {
              ...item,
              position: {
                ...item.position,
                y: e.target.value,
              },
            }
          : item
      ),
    }));
  }

  return (
    <PositionFormView
      selectedLabelItem={selectedLabelItem}
      selectedLabelItemIndex={selectedLabelItemIndex}
      onXPositionChange={onXPositionChange}
      onYPositionChange={onYPositionChange}
      submitError={submitError}
    />
  );
}

export default PositionForm;
